export default {
  iAmWorker: '标注员', // 大标题栏
  iAmPublisher: '发布者', // 大标题栏
  rechargepoint: '充值', // 以下 小标题栏
  mypoints: '我的泛函币',
  mypoints2: '可用泛函币',
  newtask: '创建项目',
  publishtodo: '待发布的项目',
  subNavTit1: '待提交任务',
  subNavTit2: '审核进度',
  subNavTit3: '泛函币管理',
  subNavTit4: '我的项目',
  subNavTit5: '数据集管理',
  subNavTit6: '充值记录',
  subNavTit7: '发票管理',
  subNavTit8: '合同管理',
  subNavTit9: '提现记录',
  subNavTit10: '收入明细',
  credits: '泛函币',
  tax: '税',
  js: {
    error: '失败',
    success: '成功'
  },
  account: {
    overfiew: '可提现泛函币',
    integral: '可提现泛函币：',
    forecastcredits: '预计可提现泛函币',
    truebalancerecharge: '实际剩余泛函币',
    forecastBalancerecharge: '预计剩余泛函币',
    exchange: '兑换提现'
  },
  join: {
    takepart: '参与的项目',
    name: '名称',
    typeStr: '类型',
    taskFlagStr: '状态',
    operate: '操作',
    see: '查看'
  },
  publish: {
    taskmanage: '项目管理',
    createtask: '创建项目',
    release: '发布中',
    taskandname: '项目编号&名称',
    number: '编号',
    name: '名称',
    starttime: '预发布日期',
    taskstate: '状态',
    operate: '操作',
    alterinfo: '修改',
    businessinfo: '任务设计',
    detailinfo: '详细信息',
    offer: '价格与质量管控',
    example: '样例',
    course: '教程',
    audit: '提交',
    publish: '发布',
    puslished: '已发布',
    releasetime: '发布日期',
    total: '总量',
    finished: '完成量',
    unfinished: '未完成量',
    js: {
      error: {
        type1: '警告',
        type2: '取消'
      },
      success: {
        type1: '确定',
        type2: '提交成功',
        type3: '发布成功',
        type4: '删除成功'
      },
      reviewing: '正在审核',
      pushReview: '项目提交审核后，将无法再修改信息，是否继续？',
      delTask: '是否确定删除项目，删除后无法撤销，是否继续？'
    }
  },
  recharge: {
    title: '账户充值',
    recharge: '充值数量:',
    rechargeremarks: '备注:',
    thisRecharge: '本次充值：',
    rechargeBtn: '确认充值',
    way: '支付方式：',
    js: {
      rules1: '充值泛函币不能少于100',
      rules2: '请输入充值泛函币',
      rules3: '充值泛函币必须为数值'
    }
  },
  nosubmitted: {
    nosubmitted0: '项目ID',
    nosubmitted1: '请输入项目ID',
    nosubmitted2: '状态',
    nosubmitted3: '待提交',
    nosubmitted4: '拒绝待修改',
    nosubmitted5: '查询',
    nosubmitted6: '重置',
    nosubmitted7: '请选择',
    nosubmitted8: '项目名称',
    nosubmitted9: '任务ID',
    nosubmitted12: '操作',
    nosubmitted13: '剩余提交时间',
    nosubmitted14: '继续',
    nosubmitted15: '修改',
    mytaskid2: '项目状态',
    mytaskid3: '进行中',
    mytaskid4: '暂停',
    num: '序号'
  },
  records: {
    transrecord: '交易记录',
    money: '金额',
    time: '时间',
    realamount: '实际提现',
    remarks: '备注',
    taskId: '任务ID'
  },
  withdraw: {
    integral: '可用泛函币：',
    money: '元',
    note: '注：100泛函币=1.00元,100个泛函币起可提现',
    note1: '(注：100泛函币=1元人民币）',
    spendPoints: '提现数量',
    putforward: '提现方式：',
    alipay: '支付宝',
    bindID: '绑定账号',
    haveInter: '剩余泛函币：',
    alipayaccount: '账户',
    pleaseinput: '请输入',
    inter: '泛函币',
    redeemnow: '申请提现',
    confirminfo: '请确认提现信息是否正确，如有错误请返回上一页修改',
    amountcash: '本次提现：',
    cumulation: '本月累积提现',
    tax: '本次代扣税',
    really: '本次实际到账',
    reset: '取消',
    confirm: '确认',
    incomes: '个人所得税',
    message1: '需先绑定支付账号，请点击下方“绑定账号”',
    exchange: '本周汇率',
    cny: '人民币',
    usd: '美元',
    js: {
      rules: {
        account: '请关联账户',
        name1: '请输入支付宝姓名',
        name2: '你输入的姓名与身份证姓名不匹配',
        spendPoints1: '提现泛函币不能少于100,且不可超过可提现泛函币',
        spendPoints2: '请输入需提现的泛函币数量',
        spendPoints3: '请输入数字'
      }
    }
  },
  receipt: {
    prompt1: '申请发票金额超过500元免收快递费',
    toInvoice: '申请开票',
    created: '申请时间',
    title: '发票抬头',
    type1: '发票类型',
    type2: '普通发票',
    type3: '专用发票',
    step1: '发票状态',
    step2: '已完成',
    step3: '已申请'
  },
  invoice: {
    amount: '开票金额',
    invoiceinfo: '开票信息',
    invoicetypt: '发票抬头类型',
    person: '个人',
    company: '企业单位',
    personName: '个人名称',
    companyName: '企业名称',
    govcode: '纳税人识别号',
    add: '和',
    bank: '开户行',
    bankaccount: '账号',
    addressphone: '地址和电话',
    corpaddress: '公司地址',
    corpphone: '公司电话',
    invoiceCon: '发票内容',
    services: '技术服务',
    taxRate: '税率',
    sendinfo: '收件信息',
    sendname: '收件姓名',
    sendphone: '联系方式',
    sendaddress: '收件地址',
    checkInvoice: '确认申请',
    js: {
      amount1: '请输入开票金额',
      amount2: '提现金额必须为数值',
      invoicetypt: '请选择发票抬头类型',
      type: '请选择发票类型',
      title: '请填写发票抬头',
      govcode: '请输入纳税人识别号',
      sendname: '请输入收件姓名',
      sendphone: '请输入联系方式',
      sendaddress: '请输入收件地址'
    }
  },
  limitMgr: {
    limitMgr: '权限管理',
    usernameNote: '输入用户名或用户名前缀（不支持空格，换行）',
    limit: '权限',
    please: '请选择权限',
    nolimit: '无权限',
    taskdo: '做任务',
    check: '审核',
    update: '更新',
    return: '返回',
    reports: '报表',
    js: {
      rule: {
        username: '请输入用户名或用户名前缀（不支持空格，换行）',
        puflag: '请选择权限'
      },
      success: '修改成功'
    }
  },
  income: {
    str1: '明细账单',
    str2: '日结账单',
    str3: '今日',
    str4: '本周',
    str5: '本月',
    str6: '开始日期',
    str7: '结束日期',
    str8: '所有泛函币',
    str9: '任务泛函币',
    str10: '管理员发放的泛函币',
    str11: '技能考试泛函币',
    str12: '泛团泛函币',
    str13: '查询',
    str14: '日期',
    str15: '编号',
    str16: '类型',
    str17: '备注',
    see: '查看',
    reset: '重置',
    to: '至',
    date: '日期',
    operation: '操作'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/workbench.js